// @flow

import * as React from 'react';

import { superpathjoin } from 'superpathjoin';

import { selectCurrentId } from '@gandi/redux-sharing';
import { useTranslator, mapTags } from '@gandi/translate';
import { Base } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { selectAdminURL } from '../../../modules/config';

import { selectShopOrgaList } from './modules/selectors';

type Props = {
  orgId: string,
};

export default function LinkToAdminOrga({ orgId }: Props): React.MixedElement {
  const { __ } = useTranslator();
  const adminUrl = useAppSelector(selectAdminURL);
  const currentId = useAppSelector(selectCurrentId);
  const shopOrgaList = useAppSelector(selectShopOrgaList);

  const orga = shopOrgaList.find(org => org.id === orgId);

  // here we handle the case when
  // the orgaId is not found into the shopOrgaList
  // however as the orgaId is set by selecting from this list
  // it should never be the case
  const editProfileHref = orga
    ? superpathjoin(
        adminUrl,
        'organizations',
        currentId,
        'organizations',
        orga.name,
        orgId,
        'profile',
        'edit',
      )
    : undefined;

  const linkWording = __('organizations menu');

  return (
    <Base tagName="p" color="light">
      {mapTags(__('You should change the currency though [[link:]].'), () => ({
        link: editProfileHref ? (
          <a href={editProfileHref}>{linkWording}</a>
        ) : (
          linkWording
        ),
      }))}
    </Base>
  );
}
